import axios from "axios";

const config = { headers: { "Content-Type": "application/json" }};

const API = {
  // AUTH APIs
  login: function (data) {
    return axios.post("/auth/login", data, config);
  },

  signup: function (data) {
    return axios.post("/auth/register", data, config);
  },

  fetchApprovedDomains: function () {
    return axios.get("/auth/email-domains");
  },

  fetchBetaEmails: function () {
    return axios.get("/auth/beta-access");
  },

  fetchApprovedEmails: function () {
    return axios.get("/auth/approved-emails");
  },

  fetchAllowedEmails: function () {
    return axios.get("/auth/allowed-emails");
  },

  confirmRegistraionEmail: function (token) {
    return axios.post("/auth/confirm-registration", {token});
  },

  getLegislationAccess: function (user_id) {
    return axios.get("/auth/legislation-access/" + user_id);
  },

  updatePassword: function (data) {
    return axios.post("/auth/update-password/", data, config);
  },

  captchaVerify: function (data) {
    return axios.post("/auth/verify", data, config);
  },

  requestPasswordReset: function (email, token) {
    return axios.post("/auth/request-password-reset", {email: email, reCaptcha_token: token});
  },

  resetPassword: function (token, password) {
    return axios.post("/auth/reset-password/" + token, {password: password})
  },

  // NEWS APIs
  getNews: function () {
    return axios.get("/api/news");
  },

  trackHeadlineClick: function (headline_id) {
    return axios.post(`/api/news/${headline_id}/click`);
  },

  // DASHBOARD APIs
  getDashboardCounts: function () {
    return axios.get("/api/dashboard/counts");
  },

  getDashboardHearings: function (date) {
    return axios.get("/api/dashboard/hearings", { params: { date } });
  },

  getDashboardHeadlines: function () {
    return axios.get("/api/dashboard/headlines");
  },

  getDashboardTracking: function (user_id) {
    return axios.get("/api/dashboard/tracking", { params: { user_id } });
  },

  getDashboardRulemaking: function () {
    return axios.get("/api/dashboard/rulemaking");
  },

  getDashboardTopPosts: function () {
    return axios.get("/api/dashboard/top-posts");
  },

  getDashboardWorkspace: function (user_id) {
    return axios.get("/api/dashboard/workspace", { params: { user_id } });
  },

  getDashboardTrackedBills: function (user_id) {
    return axios.get("/api/dashboard/tracked-bills", { params: { user_id } });
  },

  // POSTS APIs
  getPosts: function (offset, limit, sort, post_type, search, organization_id, post_author) {
    return axios.post(`/api/posts/all`, { offset, limit, sort, post_type, search, organization_id, post_author });
  },

  getPostsByType: function (postType, offset, limit) {
    return axios.post(`/api/posts-by-type`, {postType, offset, limit});
  },

  getAllPostTypes: function () {
    return axios.get("/api/posts/post-types");
  },

  getAllEventTypes: function () {
    return axios.get("/api/posts/event-types");
  },

  getSinglePostType: function (id) {
    return axios.get("/api/posts/post-type/" + id);
  },

  getSingleEventType: function (id) {
    return axios.get("/api/posts/event-type/" + id);
  },

  addNewPost: function (data) {
    return axios.post("/api/posts/add-post", data);
  },

  updatePost: function (data) {
    return axios.post("/api/posts/update-post", data);
  },

  deletePost: function (data) {
    return axios.delete("/api/posts/delete-post", {data: data});
  },

  getSinglePost: function (post_id) {
    return axios.get(`/api/posts/${post_id}`);
  },

  addNewComment: function (data) {
    return axios.post("/api/posts/add-comment", data);
  },

  updateComment: function (data) {
    return axios.post("/api/posts/update-comment", data);
  },

  deleteComment: function (data) {
    return axios.delete("/api/posts/delete-comment", {data: data});
  },

  addNewLike: function (data) {
    return axios.post("/api/posts/add-like", data);
  },

  updatePostLikes: function (data) {
    return axios.post("/api/posts/update-likes", data);
  },

  getUserLikes: function (id) {
    return axios.post("/api/posts/get-likes/" + id);
  },

  updateReadCount: function (data) {
    return axios.post("/api/posts/update-read-count", data);
  },

  getProfileDataForPost: function (user_id) {
    return axios.post("/api/posts/profile-info", {data: user_id});
  },
  
  // DIRECTORY APIs
  getDirectoryProfiles: function () {
    return axios.get(`/api/profiles/directory`);
  },

  getProfileMatch: function (data) {
    return axios.post("/api/profiles/new-user-check", data);
  },

  // ORGANIZATION & DIVISION APIs
  getOrganizations: function () {
    return axios.get("/api/orgs/");
  },

  getDirectoryOrganizations: function () {
    return axios.get("/api/orgs/?directory=true");
  },

  getOrganizationGroups: function () {
    return axios.get("/api/orgs/organization-groups");
  },
  
  getSingleOrganizations: function (id) {
    return axios.get("/api/orgs/" + id);
  },

  addOrganization: function (data) {
    return axios.post("/api/orgs/add-organization", data);
  },

  getOrgIssueProfile: function (id) {
    return axios.get("/api/orgs/" + id + "/issue-profile");
  },

  getOrgEmergingBills: function (id) {
    return axios.get("/api/orgs/" + id + "/issue-profile/emerging");
  },

  getOrgWatchList: function (id) {
    return axios.get("/api/orgs/" + id + "/issue-profile/watch");
  },

  getOrgRulemaking: function (id) {
    return axios.get("/api/orgs/" + id + "/issue-profile/rulemaking");
  },

  getSingleOrganizationName: function (id) {
    return axios.get("/api/orgs/organization-name/" + id);
  },

  updateOrganizationInfo: function (data) {
    return axios.post("/api/orgs/update-organization", data);
  },

  uploadOrganizationLogo: function (data) {
    console.log("in API: ", data)
    return axios.post("/api/orgs/upload-organization-logo", data);
  },
  
  addDivision: function (data) {
    return axios.post("/api/orgs/add-division", data);
  },

  getSingleDivision: function (id) {
    return axios.get("/api/orgs/division/" + id);
  },

  updateDivision: function (data) {
    return axios.post("/api/orgs/update-division", data);
  },

  getSingleDivisionName: function (id) {
    return axios.get("/api/orgs/division-name/" + id);
  },
  
  getDivisionsByOrgId: function (id) {
    return axios.get("/api/orgs/divisions/" + id);
  },

  
  // PROFILE APIs
  createProfile: function (data) {
    return axios.post("/api/profiles/create-profile", data);
  },

  getSingleProfile: function (id) {
    return axios.get("/api/profiles/profile/" + id);
  },

  getProfileUserCheck: function () {
    return axios.get("/api/profiles/user-check");
  },

  getOrganizationColleagues: function (data) {
    return axios.post("/api/profiles/organization-colleagues", data)
  },

  getDivisionColleagues: function (data) {
    return axios.post("/api/profiles/division-colleagues", data)
  },

  claimProfile: function (data) {
    return axios.post("/api/profiles/claim/" + data.profile_id, data);
  },

  getIssueAreas: function () {
    return axios.get("/api/issues/");
  },
  
  addIssueArea: function (data) {
    return axios.post("/api/issues/add-issue-area", data);
  },
  
  addUserIssue: function (data) {
    return axios.post("/api/issues/add-user-issue", data);
  },

  deleteUserIssue: function (data) {
    return axios.delete("/api/issues/delete-user-issue", {data: data});
  },

  getAdminIssueAreas: function () {
    return axios.get("/api/issues/admin-list");
  },

  updateIssueArea: function (data) {
    return axios.put("/api/issues/update-issue-area", data);
  },

  deleteIssueArea: function (data) {
    return axios.delete("/api/issues/delete-issue-area", { data });
  },

  consolidateIssueAreas: function (data) {
    return axios.post("/api/issues/consolidate-issue-areas", data);
  },

  getApprovedDomains: function () {
    return axios.get("/api/admin/approved-domains");
  },

  addApprovedDomain: function (data) {
    return axios.post("/api/admin/approved-domains", data);
  },

  updateApprovedDomain: function (domain_id, data) {
    return axios.put(`/api/admin/approved-domains/${domain_id}`, data);
  },

  deleteApprovedDomain: function (domain_id) {
    return axios.delete(`/api/admin/approved-domains/${domain_id}`);
  },

  getApprovedEmailsList: function () {
    return axios.get("/api/admin/approved-emails");
  },

  addApprovedEmailEntry: function (data) {
    return axios.post("/api/admin/approved-emails", data);
  },

  updateApprovedEmailEntry: function (email_id, data) {
    return axios.put(`/api/admin/approved-emails/${email_id}`, data);
  },

  deleteApprovedEmailEntry: function (email_id) {
    return axios.delete(`/api/admin/approved-emails/${email_id}`);
  },

  getAdminHearings: function () {
    return axios.get("/api/admin/hearings");
  },

  addAdminHearing: function (data) {
    return axios.post("/api/admin/hearings", data);
  },

  updateAdminHearing: function (type, id, data) {
    return axios.put(`/api/admin/hearings/${type}/${id}`, data);
  },

  deleteAdminHearing: function (type, id) {
    return axios.delete(`/api/admin/hearings/${type}/${id}`);
  },

  getHouseDistricts: function (prefix) {
    return axios.get("/api/districts/house/" + prefix);
  },

  getDistrictInfo: function (district) {
    return axios.get("/api/districts/" + district);
  },

  getLegislativeTransition: function (session) {
    return axios.get("/api/admin/legislative-transition", { params: { session } });
  },

  applyLegislativeTransition: function (data) {
    return axios.post("/api/admin/legislative-transition", data);
  },

  updateBetaEmail: function (beta_id, data) {
    return axios.put(`/api/admin/beta-emails/${beta_id}`, data);
  },

  deleteBetaEmail: function (beta_id) {
    return axios.delete(`/api/admin/beta-emails/${beta_id}`);
  },

  addJobExperience: function (data) {
    return axios.post("/api/profiles/add-job/", data);
  },

  uploadProfilePicture: function (data) {
    return axios.post("/api/profiles/upload-profile-picture", data);
  },

  updateProfileInfo: function (data) {
    return axios.post("/api/profiles/update-profile", data);
  },

  updateJobExperience: function (data) {
    return axios.post("/api/profiles/update-job/", data);
  },

  deleteJobExperience: function (data) {
    return axios.delete("/api/profiles/delete-job", {data: data});
  },

  updateBiography: function (data) {
    return axios.post("/api/profiles/bio/" + data.profile_id, data);
  },

  // FEEDBACK APIs
  submitFeedback: function (data) {
    return axios.post("/api/feedback", data);
  },

  getAdminFeedback: function (params = {}) {
    return axios.get("/api/admin/feedback", { params });
  },

  getAdminFeedbackUnreadCount: function () {
    return axios.get("/api/admin/feedback/unread-count");
  },

  getNotificationUnreadCount: function (user_id) {
    return axios.get("/api/notifications/unread-count", { params: { user_id } });
  },

  getNotifications: function (params = {}) {
    return axios.get("/api/notifications", { params });
  },

  markNotificationRead: function (id, user_id) {
    return axios.put(`/api/notifications/${id}/read`, { user_id });
  },

  markNotificationUnread: function (id, user_id) {
    return axios.put(`/api/notifications/${id}/unread`, { user_id });
  },

  archiveNotification: function (id, user_id) {
    return axios.put(`/api/notifications/${id}/archive`, { user_id });
  },

  unarchiveNotification: function (id, user_id) {
    return axios.put(`/api/notifications/${id}/unarchive`, { user_id });
  },

  markAllNotificationsRead: function (user_id) {
    return axios.put("/api/notifications/read-all", { user_id });
  },

  getNotificationDigestItems: function (id, user_id) {
    return axios.get(`/api/notifications/${id}/digest-items`, { params: { user_id } });
  },

  updateAdminFeedback: function (id, data) {
    return axios.put(`/api/admin/feedback/${id}`, data);
  },

  getFeedbackNotes: function (id) {
    return axios.get(`/api/admin/feedback/${id}/notes`);
  },

  addFeedbackNote: function (id, note_text) {
    return axios.post(`/api/admin/feedback/${id}/notes`, { note_text });
  },

  closeoutFeedback: function (id, closeout_note) {
    return axios.put(`/api/admin/feedback/${id}/closeout`, { closeout_note });
  },

  // LEGISLATION CONTACTS APIs
  getBillContacts: function (billId) {
    return axios.get(`/api/legislation/contacts/${billId}`);
  },

  searchProfilesForContact: function (query, hasUser = false) {
    return axios.get(`/api/legislation/contacts/search?query=${encodeURIComponent(query)}${hasUser ? '&hasUser=true' : ''}`);
  },

  addBillContact: function (data) {
    return axios.post("/api/legislation/contacts", data);
  },

  deleteBillContact: function (contactId) {
    return axios.delete(`/api/legislation/contacts/${contactId}`);
  },

  makeContactUniversal: function (contactId) {
    return axios.put(`/api/legislation/contacts/universal/${contactId}`);
  },

  deUniversalizeContact: function (contactId, userId) {
    return axios.put(`/api/legislation/contacts/de-universalize/${contactId}`, { user_id: userId });
  },

  shareContactWithTeam: function (contactId, teamId, userId) {
    return axios.put(`/api/legislation/contacts/team/${contactId}`, { team_id: teamId, user_id: userId });
  },

  makeContactPersonal: function (contactId, userId) {
    return axios.put(`/api/legislation/contacts/personal/${contactId}`, { user_id: userId });
  },

  // Bill Tracking APIs
  getTrackedBills: function (user_id) {
    return axios.get(`/api/legislation/tracked-bills/${user_id}`);
  },

  getReviewedBills: function (user_id) {
    return axios.get(`/api/legislation/reviews/${user_id}`);
  },

  toggleBillReview: function (data) {
    return axios.post('/api/legislation/review', data);
  },

  trackBill: function (data) {
    return axios.post('/api/legislation/track-bill', data);
  },

  expressLegislationInterest: function (user_id) {
    return axios.post("/api/legislation/interest", { user_id });
  },

  getTeamsAccess: function (user_id) {
    return axios.get("/auth/teams-access/" + user_id);
  },

  expressTeamsInterest: function (user_id) {
    return axios.post("/auth/teams-interest", { user_id });
  },

  // SUBSCRIPTION APIs
  getSubscriptionStatus: function (user_id) {
    return axios.get("/api/subscriptions/status", { params: { user_id } });
  },

  createCheckout: function (data) {
    return axios.post("/api/subscriptions/checkout", data);
  },

  // AMBASSADOR APIs (self-service)
  getMyAmbassadorInfo: function () {
    return axios.get("/api/ambassadors/me");
  },

  sendAmbassadorInvite: function (data) {
    return axios.post("/api/ambassadors/send-invite", data);
  },

  registerAndCheckout: function (data) {
    return axios.post("/auth/register-and-checkout", data, config);
  },

  // AWARDS APIs
  getAwardSettings: function () {
    return axios.get('/api/awards/settings');
  },

  searchNominees: function (q) {
    return axios.get('/api/awards/search-nominees', { params: { q } });
  },

  getNominationInfo: function (token) {
    return axios.get('/api/awards/nomination-info/' + token);
  },

  acceptNomination: function (token) {
    return axios.get('/api/awards/accept/' + token);
  },

  declineNomination: function (token) {
    return axios.post('/api/awards/decline/' + token);
  },

  getAwardCategories: function () {
    return axios.get('/api/awards/categories');
  },

  submitNomination: function (data) {
    return axios.post('/api/awards/nominate', data);
  },

  getMyNominations: function () {
    return axios.get('/api/awards/my-nominations');
  },

  getVotingBallot: function () {
    return axios.get('/api/awards/ballot');
  },

  castVote: function (data) {
    return axios.post('/api/awards/vote', data);
  },

  // App settings (public)
  getAppSettings: function () {
    return axios.get('/api/settings');
  },

  // ADMIN APIs
  adminGetSettings: function () {
    return axios.get('/api/admin/settings');
  },

  adminUpdateSettings: function (data) {
    return axios.put('/api/admin/settings', data);
  },

  adminGetAllSessions: function () {
    return axios.get('/api/admin/sessions');
  },

  adminGetUsers: function (search, letter) {
    return axios.get("/api/admin/users", { params: { search, letter } });
  },

  adminGetUserDetail: function (user_id) {
    return axios.get(`/api/admin/users/${user_id}`);
  },

  adminGetUserActivity: function (user_id) {
    return axios.get(`/api/admin/users/${user_id}/activity`);
  },

  adminSetUserSubscription: function (user_id, individual_subscription, end_date) {
    return axios.put(`/api/admin/users/${user_id}/subscription`, { individual_subscription, end_date });
  },

  adminSetContributor: function (user_id, contributor) {
    return axios.put(`/api/admin/users/${user_id}/contributor`, { contributor });
  },

  adminSetUserWorkplace: function (user_id, workplace_subscription, end_date) {
    return axios.put(`/api/admin/users/${user_id}/workplace`, { workplace_subscription, end_date });
  },

  adminUpdateUserEmail: function (user_id, email) {
    return axios.put(`/api/admin/users/${user_id}/email`, { email });
  },

  adminGetTeams: function () {
    return axios.get("/api/admin/teams");
  },

  adminSetTeamSubscription: function (team_id, workplace_subscription, end_date) {
    return axios.put(`/api/admin/teams/${team_id}/subscription`, { workplace_subscription, end_date });
  },

  adminGetTeamDetail: function (team_id) {
    return axios.get(`/api/admin/teams/${team_id}`);
  },

  adminSetTeamOrganization: function (team_id, organization_id) {
    return axios.put(`/api/admin/teams/${team_id}/organization`, { organization_id });
  },

  adminAddTeamMember: function (team_id, user_id) {
    return axios.post(`/api/admin/teams/${team_id}/members`, { user_id });
  },

  adminRemoveTeamMember: function (team_id, member_id) {
    return axios.delete(`/api/admin/teams/${team_id}/members/${member_id}`);
  },

  adminGetOrganizations: function () {
    return axios.get("/api/admin/organizations");
  },

  adminCreateOrganization: function (data) {
    return axios.post("/api/admin/organizations", data);
  },

  adminCreateDivision: function (data) {
    return axios.post("/api/admin/divisions", data);
  },

  adminCreateProfile: function (data) {
    return axios.post("/api/admin/create-profile", data);
  },

  adminGetAwardSettings: function () {
    return axios.get('/api/awards/admin/settings');
  },

  adminSaveAwardSettings: function (data) {
    return axios.put('/api/awards/admin/settings', data);
  },

  adminGetNominations: function (params) {
    return axios.get('/api/awards/admin/nominations', { params });
  },

  adminGetAwardVotes: function (params) {
    return axios.get('/api/awards/admin/votes', { params });
  },

  adminGetRounds: function () {
    return axios.get('/api/awards/admin/rounds');
  },

  adminCreateRound: function (data) {
    return axios.post('/api/awards/admin/rounds', data);
  },

  adminUpdateRound: function (roundId, data) {
    return axios.put(`/api/awards/admin/rounds/${roundId}`, data);
  },

  adminActivateRound: function (roundId) {
    return axios.put(`/api/awards/admin/rounds/${roundId}/activate`);
  },

  adminDeleteRound: function (roundId) {
    return axios.delete(`/api/awards/admin/rounds/${roundId}`);
  },

  adminGetRoundCategories: function (roundId) {
    return axios.get(`/api/awards/admin/rounds/${roundId}/categories`);
  },

  adminCreateCategory: function (roundId, data) {
    return axios.post(`/api/awards/admin/rounds/${roundId}/categories`, data);
  },

  adminUpdateCategory: function (categoryId, data) {
    return axios.put(`/api/awards/admin/categories/${categoryId}`, data);
  },

  adminDeleteCategory: function (categoryId) {
    return axios.delete(`/api/awards/admin/categories/${categoryId}`);
  },

  // ADMIN — AMBASSADORS
  adminSetUserAmbassador: function (user_id) {
    return axios.post(`/api/admin/users/${user_id}/ambassador`);
  },

  adminUnsetUserAmbassador: function (user_id) {
    return axios.delete(`/api/admin/users/${user_id}/ambassador`);
  },

  adminGetAmbassadors: function () {
    return axios.get("/api/admin/ambassadors");
  },

  adminGetAmbassadorSettings: function () {
    return axios.get("/api/admin/ambassador-settings");
  },

  adminGetAmbassadorDetail: function (ambassador_id) {
    return axios.get(`/api/admin/ambassadors/${ambassador_id}`);
  },

  adminUpdateAmbassadorRate: function (ambassador_id, data) {
    return axios.put(`/api/admin/ambassadors/${ambassador_id}`, data);
  },

  adminBulkUpdateAmbassadorRate: function (data) {
    return axios.put("/api/admin/ambassadors/bulk-rate", data);
  },

  adminCreateAmbassadorPayout: function (ambassador_id, data) {
    return axios.post(`/api/admin/ambassadors/${ambassador_id}/payouts`, data);
  },

  adminDeleteAmbassadorPayout: function (ambassador_id, payout_id) {
    return axios.delete(`/api/admin/ambassadors/${ambassador_id}/payouts/${payout_id}`);
  },

  // ADMIN — WORKSPACE AMBASSADORS
  adminEnableTeamAmbassador: function (teamId, data) {
    return axios.post(`/api/admin/teams/${teamId}/ambassador`, data);
  },

  adminUpdateTeamAmbassadorRate: function (teamId, data) {
    return axios.put(`/api/admin/teams/${teamId}/ambassador`, data);
  },

  adminDisableTeamAmbassador: function (teamId) {
    return axios.delete(`/api/admin/teams/${teamId}/ambassador`);
  },

  // ACTIVITY APIs
  logUserActivity: function (data) {
    return axios.post("/api/activity", data);
  },

  // TEAMS APIs
  createTeam: function (data) {
    return axios.post("/api/teams", data);
  },

  getUserTeams: function (params) {
    return axios.get("/api/teams/my-teams", { params });
  },

  getTeamDetails: function (teamId) {
    return axios.get("/api/teams/" + teamId);
  },

  getTeamAmbassadorOverview: function (teamId, params) {
    return axios.get(`/api/teams/${teamId}/ambassador-overview`, { params });
  },

  getEligibleMembers: function (teamId) {
    return axios.get(`/api/teams/${teamId}/members/eligible`);
  },

  inviteTeamMember: function (teamId, data) {
    return axios.post(`/api/teams/${teamId}/members/invite`, data);
  },

  searchTeamMembers: function (teamId, query) {
    return axios.get(`/api/teams/${teamId}/members/search?q=${encodeURIComponent(query)}`);
  },

  addTeamMember: function (teamId, data) {
    return axios.post(`/api/teams/${teamId}/members`, data);
  },

  updateMemberPermissions: function (teamId, memberId, data) {
    return axios.put(`/api/teams/${teamId}/members/${memberId}`, data);
  },

  removeTeamMember: function (teamId, memberId) {
    return axios.delete(`/api/teams/${teamId}/members/${memberId}`);
  },

  getMyPendingInvites: function (userId) {
    return axios.get("/api/teams/my-invites", { params: { user_id: userId } });
  },

  acceptTeamInvite: function (teamId, memberId, userId) {
    return axios.put(`/api/teams/${teamId}/members/${memberId}/accept`, { user_id: userId });
  },

  declineTeamInvite: function (teamId, memberId, userId) {
    return axios.put(`/api/teams/${teamId}/members/${memberId}/decline`, { user_id: userId });
  },

  updateTeamName: function (teamId, data) {
    return axios.put(`/api/teams/${teamId}`, data);
  },

  deleteTeam: function (teamId, userId) {
    return axios.delete(`/api/teams/${teamId}`, { params: { user_id: userId } });
  },

  // Bill tracking modal
  getBillTrackingModal: function (billId, userId) {
    return axios.get(`/api/teams/tracking-modal/${billId}`, { params: { user_id: userId } });
  },

  saveBillTracking: function (data) {
    return axios.post('/api/teams/save-tracking', data);
  },

  untrackBill: function (data) {
    return axios.delete('/api/teams/untrack', { data });
  },

  // Team Organization
  searchOrganizations: function (q) {
    return axios.get('/api/orgs/search', { params: { q } });
  },

  setTeamOrganization: function (teamId, data) {
    return axios.put(`/api/teams/${teamId}/organization`, data);
  },

  // Team Clients
  getTeamClients: function (teamId) {
    return axios.get(`/api/teams/${teamId}/clients`);
  },

  createTeamClient: function (teamId, data) {
    return axios.post(`/api/teams/${teamId}/clients`, data);
  },

  updateTeamClient: function (teamId, clientId, data) {
    return axios.put(`/api/teams/${teamId}/clients/${clientId}`, data);
  },

  archiveTeamClient: function (teamId, clientId, userId) {
    return axios.patch(`/api/teams/${teamId}/clients/${clientId}/archive`, { user_id: userId });
  },

  unarchiveTeamClient: function (teamId, clientId, userId) {
    return axios.patch(`/api/teams/${teamId}/clients/${clientId}/unarchive`, { user_id: userId });
  },

  deleteTeamClient: function (teamId, clientId, userId) {
    return axios.delete(`/api/teams/${teamId}/clients/${clientId}`, { params: { user_id: userId } });
  },

  // Team Client Contacts
  createTeamClientContact: function (teamId, clientId, data) {
    return axios.post(`/api/teams/${teamId}/clients/${clientId}/contacts`, data);
  },

  updateTeamClientContact: function (teamId, clientId, contactId, data) {
    return axios.put(`/api/teams/${teamId}/clients/${clientId}/contacts/${contactId}`, data);
  },

  deleteTeamClientContact: function (teamId, clientId, contactId, userId) {
    return axios.delete(`/api/teams/${teamId}/clients/${clientId}/contacts/${contactId}`, { params: { user_id: userId } });
  },

  // New Team Tracking APIs
  getTeamTrackedBills: function (user_id) {
    return axios.get('/api/teams/team-tracked-bills', { params: { user_id } });
  },

  getUserTeamsForBillTracking: function (billId, userId) {
    return axios.get(`/api/teams/tracking-options/${billId}`, { params: { user_id: userId } });
  },

  updateTeamTrackedBill: function (data) {
    return axios.post('/api/teams/track-bill', data);
  },

  updateClientTrackedBill: function (data) {
    return axios.post('/api/teams/track-client-bill', data);
  },

  // Client filter — all clients across the user's lobbyist-type teams
  getAllClients: function (user_id) {
    return axios.get('/api/teams/all-clients', { params: { user_id } });
  },

  // Saved filter presets
  getAiSummarySessions: function () {
    return axios.get('/api/legislation/ai-summary-sessions');
  },

  getSavedFilters: function () {
    return axios.get('/api/legislation/saved-filters');
  },

  createSavedFilter: function (name, filter_json) {
    return axios.post('/api/legislation/saved-filters', { name, filter_json });
  },

  updateSavedFilter: function (filter_id, name, filter_json) {
    return axios.put(`/api/legislation/saved-filters/${filter_id}`, { name, filter_json });
  },

  deleteSavedFilter: function (filter_id) {
    return axios.delete(`/api/legislation/saved-filters/${filter_id}`);
  },

  // Workspace (team-shared) saved filter presets
  getTeamSavedFilters: function (team_id) {
    return axios.get(`/api/teams/${team_id}/saved-filters`);
  },

  createTeamSavedFilter: function (team_id, user_id, name, filter_json) {
    return axios.post(`/api/teams/${team_id}/saved-filters`, { user_id, name, filter_json });
  },

  updateTeamSavedFilter: function (team_id, filter_id, user_id, name, filter_json) {
    return axios.put(`/api/teams/${team_id}/saved-filters/${filter_id}`, { user_id, name, filter_json });
  },

  deleteTeamSavedFilter: function (team_id, filter_id, user_id) {
    return axios.delete(`/api/teams/${team_id}/saved-filters/${filter_id}`, { params: { user_id } });
  },

  // Client Feedback
  getClientTrackedBills: function (teamId, clientId) {
    return axios.get(`/api/teams/${teamId}/clients/${clientId}/tracked-bills`);
  },

  getWorkspaceTrackedBills: function (teamId) {
    return axios.get(`/api/teams/${teamId}/tracked-bills`);
  },

  searchBills: function (query) {
    const params = { limit: 10, current_only: 'true' };
    const q = query.trim();
    const billPattern = /^([A-Za-z]{1,4})\s+(\d+)$/;
    const compactPattern = /^([A-Za-z]{1,4})(\d+)$/;
    const match = q.match(billPattern) || q.match(compactPattern);
    if (match) {
      params.bill_type = match[1].toUpperCase();
      params.bill_number = match[2];
    } else if (/^\d+$/.test(q)) {
      params.bill_number = q;
    } else {
      params.query = q;
    }
    return axios.get('/api/legislation/bills', { params });
  },

  createFeedbackRequest: function (data) {
    return axios.post('/api/client-feedback', data);
  },

  getFeedbackRequests: function (teamId, clientId) {
    return axios.get(`/api/client-feedback/team/${teamId}`, { params: { client_id: clientId } });
  },

  getFeedbackRequestDetail: function (requestId) {
    return axios.get(`/api/client-feedback/${requestId}`);
  },

  deleteFeedbackRequest: function (requestId) {
    return axios.delete(`/api/client-feedback/${requestId}`);
  },

  resendFeedbackEmail: function (requestId, contactId) {
    return axios.post(`/api/client-feedback/${requestId}/resend/${contactId}`);
  },

  getBillClientFeedback: function (billId) {
    return axios.get(`/api/client-feedback/bill/${billId}`);
  },

  createReport: function (data) {
    return axios.post('/api/reports', data);
  },

  getTeamReports: function (teamId) {
    return axios.get(`/api/reports/team/${teamId}`);
  },

  getReportDetail: function (reportId) {
    return axios.get(`/api/reports/${reportId}`);
  },

  deleteReport: function (reportId) {
    return axios.delete(`/api/reports/${reportId}`);
  },

  sendReport: function (reportId, data) {
    return axios.post(`/api/reports/${reportId}/send`, data);
  },

  getBillHistory: function (billId) {
    return axios.get(`/api/legislation/bills/${billId}/history`);
  },

  // Bill Work — Assignments, Tasks, Notes
  getTrackedBillsOverview: function (teamId, userId) {
    return axios.get(`/api/teams/${teamId}/tracked-bills-overview`, { params: { user_id: userId } });
  },

  getTeamRulemaking: function (teamId, userId) {
    return axios.get(`/api/teams/${teamId}/rulemaking`, { params: { user_id: userId } });
  },

  addBillAssignment: function (teamId, billId, data) {
    return axios.post(`/api/teams/${teamId}/bills/${billId}/assignments`, data);
  },

  updateBillAssignment: function (teamId, billId, assignId, data) {
    return axios.put(`/api/teams/${teamId}/bills/${billId}/assignments/${assignId}`, data);
  },

  removeBillAssignment: function (teamId, billId, assignId, requestingUserId) {
    return axios.delete(`/api/teams/${teamId}/bills/${billId}/assignments/${assignId}`, { params: { requesting_user_id: requestingUserId } });
  },

  bulkReassign: function (teamId, data) {
    return axios.post(`/api/teams/${teamId}/assignments/bulk-reassign`, data);
  },

  getBillTasks: function (teamId, billId, userId) {
    return axios.get(`/api/teams/${teamId}/bills/${billId}/tasks`, { params: { user_id: userId } });
  },

  createBillTask: function (teamId, billId, data) {
    return axios.post(`/api/teams/${teamId}/bills/${billId}/tasks`, data);
  },

  updateBillTask: function (teamId, billId, taskId, data) {
    return axios.put(`/api/teams/${teamId}/bills/${billId}/tasks/${taskId}`, data);
  },

  deleteBillTask: function (teamId, billId, taskId, requestingUserId) {
    return axios.delete(`/api/teams/${teamId}/bills/${billId}/tasks/${taskId}`, { params: { requesting_user_id: requestingUserId } });
  },

  // Tasks on a rulemaking item (a notice or agency hearing) rather than a bill
  getTeamRulemakingTasks: function (teamId, userId) {
    return axios.get(`/api/teams/${teamId}/rulemaking-tasks`, { params: { user_id: userId } });
  },

  createRulemakingTask: function (teamId, data) {
    return axios.post(`/api/teams/${teamId}/rulemaking-tasks`, data);
  },

  updateRulemakingTask: function (teamId, taskId, data) {
    return axios.put(`/api/teams/${teamId}/rulemaking-tasks/${taskId}`, data);
  },

  deleteRulemakingTask: function (teamId, taskId, requestingUserId) {
    return axios.delete(`/api/teams/${teamId}/rulemaking-tasks/${taskId}`, { params: { requesting_user_id: requestingUserId } });
  },

  // Tasks tied to neither a bill nor a rulemaking item
  createTeamTask: function (teamId, data) {
    return axios.post(`/api/teams/${teamId}/tasks`, data);
  },

  updateTeamTask: function (teamId, taskId, data) {
    return axios.put(`/api/teams/${teamId}/tasks/${taskId}`, data);
  },

  // Progress notes on a task, and an assignee's request to change its due date or priority
  getTaskNotes: function (teamId, taskId, userId) {
    return axios.get(`/api/teams/${teamId}/tasks/${taskId}/notes`, { params: { user_id: userId } });
  },

  addTaskNote: function (teamId, taskId, data) {
    return axios.post(`/api/teams/${teamId}/tasks/${taskId}/notes`, data);
  },

  requestTaskChange: function (teamId, taskId, data) {
    return axios.post(`/api/teams/${teamId}/tasks/${taskId}/change-requests`, data);
  },

  // Steps within a task, each with an optional due date
  getTaskSteps: function (teamId, taskId, userId) {
    return axios.get(`/api/teams/${teamId}/tasks/${taskId}/steps`, { params: { user_id: userId } });
  },

  addTaskStep: function (teamId, taskId, data) {
    return axios.post(`/api/teams/${teamId}/tasks/${taskId}/steps`, data);
  },

  updateTaskStep: function (teamId, taskId, stepId, data) {
    return axios.put(`/api/teams/${teamId}/tasks/${taskId}/steps/${stepId}`, data);
  },

  deleteTaskStep: function (teamId, taskId, stepId, requestingUserId) {
    return axios.delete(`/api/teams/${teamId}/tasks/${taskId}/steps/${stepId}`, { params: { requesting_user_id: requestingUserId } });
  },

  getTeamTasks: function (teamId, userId, filter) {
    return axios.get(`/api/teams/${teamId}/tasks`, { params: { user_id: userId, filter } });
  },

  getBillNotes: function (teamId, billId, userId) {
    return axios.get(`/api/teams/${teamId}/bills/${billId}/notes`, { params: { user_id: userId } });
  },

  createBillNote: function (teamId, billId, data) {
    return axios.post(`/api/teams/${teamId}/bills/${billId}/notes`, data);
  },

  deleteBillNote: function (teamId, billId, noteId, requestingUserId) {
    return axios.delete(`/api/teams/${teamId}/bills/${billId}/notes/${noteId}`, { params: { requesting_user_id: requestingUserId } });
  },

  // Bill Work — Subject Tags
  getTeamSubjectTags: function (teamId, userId) {
    return axios.get(`/api/teams/${teamId}/subject-tags`, { params: { user_id: userId } });
  },

  createTeamSubjectTag: function (teamId, data) {
    return axios.post(`/api/teams/${teamId}/subject-tags`, data);
  },

  deleteTeamSubjectTag: function (teamId, tagId, requestingUserId) {
    return axios.delete(`/api/teams/${teamId}/subject-tags/${tagId}`, { params: { requesting_user_id: requestingUserId } });
  },

  getBillSubjectTags: function (teamId, billId, userId) {
    return axios.get(`/api/teams/${teamId}/bills/${billId}/subject-tags`, { params: { user_id: userId } });
  },

  addBillSubjectTag: function (teamId, billId, data) {
    return axios.post(`/api/teams/${teamId}/bills/${billId}/subject-tags`, data);
  },

  removeBillSubjectTag: function (teamId, billId, tagId, requestingUserId) {
    return axios.delete(`/api/teams/${teamId}/bills/${billId}/subject-tags/${tagId}`, { params: { requesting_user_id: requestingUserId } });
  },

  getBillSubjectTagsAcrossTeams: function (billId, userId) {
    return axios.get(`/api/teams/subject-tags/${billId}`, { params: { user_id: userId } });
  },

  // LEADERSHIP POSITION APIs
  getLeadershipPositions: function (organizationId) {
    return axios.get(`/api/leadership/${organizationId}`);
  },

  addLeadershipPosition: function (data) {
    return axios.post("/api/leadership/add", data);
  },

  updateLeadershipPosition: function (data) {
    return axios.post("/api/leadership/update", data);
  },

  deleteLeadershipPosition: function (data) {
    return axios.delete("/api/leadership/delete", { data: data });
  },
};

export default API;
